










import { Vue, Component } from 'vue-property-decorator';
import Reportes from '@/pantallas/Peajes/Reportes/Reportes.vue';

@Component({
  components: { Reportes },
})
export default class ReportesPantalla extends Vue {}
